"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable react/self-closing-comp */
const react_1 = __importStar(require("react"));
const consts_1 = __importDefault(require("~/components/Cad3d/consts/consts"));
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/consts/events");
const clampNumberInput_1 = __importStar(require("~/utils/clampNumberInput"));
const usePreventMouseUpWhileSelecting_1 = __importDefault(require("~/hooks/usePreventMouseUpWhileSelecting"));
const PopupEditable_module_scss_1 = __importDefault(require("./PopupEditable.module.scss"));
function PopupEditable(props) {
    const inputRef = (0, react_1.useRef)(null);
    const preventMouseUpWhileSelecting = (0, usePreventMouseUpWhileSelecting_1.default)(inputRef);
    const selectValueAfterRender = (0, react_1.useRef)(false);
    const positioningInput = (0, react_1.useRef)();
    const isImperial = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const [selectionRequest, setSelectionRequest] = (0, react_1.useState)(0);
    const [min, setMin] = (0, react_1.useState)(0);
    const [value, setValue] = (0, react_1.useState)(min.toFixed(2));
    const [stockLength, setStockLength] = (0, react_1.useState)(consts_1.default.DEFAULT_MAX_STOCK_LENGTH);
    const [error, setError] = (0, react_1.useState)('');
    const [positioning, setPositioning] = (0, react_1.useState)(false);
    const previewPositioningValue = (positioningValue) => {
        var _a, _b;
        const onChange = (_a = positioningInput.current) === null || _a === void 0 ? void 0 : _a.onChange;
        if (!onChange) {
            return 'This distance can only be edited while placing an item.';
        }
        const distance = Number(positioningValue) * (isImperial ? 1 : consts_1.default.MM_TO_INCH);
        return (_b = onChange(distance)) !== null && _b !== void 0 ? _b : '';
    };
    const onChangeValue = (e) => {
        const event = e;
        const newValue = Number.parseFloat(event.detail).toFixed(2);
        selectValueAfterRender.current = true;
        setPositioning(false);
        setValue(newValue);
        setSelectionRequest((current) => current + 1);
    };
    const onPositioningValue = (e) => {
        const event = e;
        positioningInput.current = event.detail;
        if (inputRef.current) {
            inputRef.current.readOnly = false;
        }
        setPositioning(true);
        setError('');
        if (!event.detail.preserveValue) {
            selectValueAfterRender.current = true;
            setValue(event.detail.value);
            setSelectionRequest((current) => current + 1);
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        var _a, _b, _c;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('width', `${value.length + 1}ch`);
        if (selectValueAfterRender.current) {
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus({ preventScroll: true });
            (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.select();
            selectValueAfterRender.current = false;
        }
    }, [selectionRequest, value]);
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.valueModalChanged, onChangeValue);
        document.body.addEventListener(events_1.positioningValueChanged, onPositioningValue);
        return () => {
            document.body.removeEventListener(events_1.valueModalChanged, onChangeValue);
            document.body.removeEventListener(events_1.positioningValueChanged, onPositioningValue);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setStockLength(consts_1.default.DEFAULT_MAX_STOCK_LENGTH * (isImperial ? 1 : consts_1.default.INCH_TO_MM));
        if (isImperial) {
            setMin(1);
        }
        else {
            setMin(1 * consts_1.default.INCH_TO_MM);
        }
    }, [isImperial]);
    const onInput = (e) => {
        var _a, _b;
        selectValueAfterRender.current = false;
        if (positioning) {
            const stringValue = e.target.value;
            setValue(stringValue);
            if (!/^\d*(?:\.\d{0,3})?$/.test(stringValue)) {
                setError('Enter a non-negative number with up to three decimal places.');
                return;
            }
            if (!stringValue || stringValue.endsWith('.')) {
                setError('');
                return;
            }
            setError(previewPositioningValue(stringValue));
            return;
        }
        const max = Number(e.target.dataset.maxStockLength) * (isImperial ? 1 : consts_1.default.INCH_TO_MM);
        const { draft, value: stringValue } = (0, clampNumberInput_1.getLengthInputValue)(e.target.value, min, max);
        const val = Number(stringValue);
        setValue(draft);
        setStockLength(max);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('width', `${stringValue.length + 1}ch`);
        Viewer_1.default.instance.changeItemSize((_b = e.target.dataset.uuid) !== null && _b !== void 0 ? _b : '', {
            z: val,
        }, isImperial);
    };
    const commitValue = () => {
        if (positioning) {
            return;
        }
        setValue((0, clampNumberInput_1.default)(value, min, stockLength));
    };
    const onKeyDown = (event) => {
        var _a, _b, _c, _d, _e;
        if (positioning) {
            if (event.key === 'Tab') {
                event.preventDefault();
                event.stopPropagation();
                (_a = positioningInput.current) === null || _a === void 0 ? void 0 : _a.onNavigate(event.shiftKey);
                return;
            }
            if (event.key !== 'Enter') {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (!/^\d+(?:\.\d{1,3})?$/.test(value)) {
                setError('Enter a non-negative number with up to three decimal places.');
                return;
            }
            const validationError = previewPositioningValue(value);
            setError(validationError);
            if (!validationError) {
                (_b = positioningInput.current) === null || _b === void 0 ? void 0 : _b.onConfirm();
            }
            return;
        }
        if (event.key.toLocaleLowerCase() === 'enter') {
            commitValue();
            Viewer_1.default.instance.pressEnter((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.dataset.uuid);
            (_d = inputRef.current) === null || _d === void 0 ? void 0 : _d.setAttribute('readonly', 'true');
            (_e = window.getSelection()) === null || _e === void 0 ? void 0 : _e.removeAllRanges();
        }
    };
    return (react_1.default.createElement("div", Object.assign({ className: PopupEditable_module_scss_1.default['popupEditable'] }, props, { "data-testid": "popup-editable" }),
        react_1.default.createElement("span", { className: isImperial ? PopupEditable_module_scss_1.default.isImperial : PopupEditable_module_scss_1.default.isMetric },
            react_1.default.createElement("input", { type: positioning ? 'text' : 'number', inputMode: positioning ? 'decimal' : undefined, id: positioning ? 'positioningLabelInput' : 'lengthLabelInput', ref: inputRef, onChange: onInput, onMouseDown: preventMouseUpWhileSelecting, min: positioning ? undefined : min, max: positioning || !Number.isFinite(stockLength) ? undefined : stockLength, onKeyDown: onKeyDown, onBlur: commitValue, value: value })),
        positioning && error && react_1.default.createElement("span", { className: PopupEditable_module_scss_1.default.error }, error)));
}
exports.default = PopupEditable;
